import { render, staticRenderFns } from "./payrollSetting.vue?vue&type=template&id=735bc6ba&scoped=true&"
import script from "./payrollSetting.vue?vue&type=script&lang=js&"
export * from "./payrollSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735bc6ba",
  null
  
)

export default component.exports